export const RailsId = {
  WUBS_DECOUPLED: 'WUBS_DECOUPLED',
  WU: 'WU',
};
